import moment from 'moment'

// What the lead's `followup_data` says about its follow-up, in the shape the UI wants. `next_followup_time` is
// unreliable after the follow-up refactor, so everything (lead card, summary bar, the set/edit dialog) reads this.
//
// followup_data: { reason, completed_at, sequences: [{ followup_time, completed_at, completed_by }] }. A follow-up is
// active while it isn't completed itself and still has an open sequence; the "next" one is the first open sequence.
export const getFollowupState = (lead) => {
  const data = lead?.followup_data
  const sequences = Array.isArray(data?.sequences) ? data.sequences : []
  const nextIndex = sequences.findIndex(s => !s?.completed_at)
  const active = Boolean(data) && !data.completed_at && nextIndex !== -1
  return {
    active,
    // a follow-up that exists but is over (completed as a whole, or every attempt done) and has a reason to show
    completed: Boolean(data) && !active && Boolean(data.reason),
    data: active ? data : null,
    reason: data?.reason || '',
    sequences,
    nextIndex,
    nextTime: active ? sequences[nextIndex]?.followup_time : null,
    doneCount: sequences.filter(s => s?.completed_at).length,
    total: sequences.length,
    since: lead?.followup_since || null,
  }
}

const ORDINALS = ['First Attempt', 'Second Attempt', 'Third Attempt', 'Fourth Attempt', 'Fifth Attempt', 'Sixth Attempt',
  'Seventh Attempt', 'Eighth Attempt', 'Ninth Attempt', 'Tenth Attempt']

// Label of the sequence at `index` (0-based): the first is the first attempt, the rest are numbered attempts.
export const getSequenceLabel = (index) => ORDINALS[index] || `Attempt ${index + 1}`

// "Add attempt" templates, in days after the previous (last) attempt's date (+1d … +6d, then +1w), always at the default
// time. Always the same set, so adding attempts one by one (or after deleting some) behaves the same every time.
export const ATTEMPT_TEMPLATES = [
  ...[1, 2, 3, 4, 5, 6].map(days => ({ label: `+${days}d`, days })),
  { label: '+1w', days: 7 },
]
export const DEFAULT_ATTEMPT_TIME = { hour: 9, minute: 0 }

export const templateTime = (base, days) => (
  moment(base).startOf('day').add(days, 'days').hour(DEFAULT_ATTEMPT_TIME.hour).minute(DEFAULT_ATTEMPT_TIME.minute)
)
